import { type IntlShape, createIntl } from 'react-intl-next';
import { proxy, ref, useSnapshot } from 'valtio';

import { getDefaultLocale } from '@canvas/constants/localization/localization-types';

import { externalMessages } from './i18n-state';

/**
 * Loads from the externalMessages object and lazily initialises a new intl object if it has not yet
 * loaded
 */
export function useExternalIntlObject(key: string) {
  const intl = externalMessages[key];
  if (!intl) {
    // We make it a proxy object so that one can subscribe to any changes to the object, eg when
    // messages have been loaded
    externalMessages[key] = proxy<{ intl: IntlShape }>({
      intl: ref(
        createIntl({ locale: getDefaultLocale(), onError: (_err: unknown) => {} })
      ),
    });
  }

  const snapshot = useSnapshot(externalMessages[key]);

  // We get a readonly snapshot of the intl object where we actually need it to be non-readonly
  // in RawIntlProviders
  return snapshot.intl as IntlShape;
}
